// dependencies
import React from "react";

// components
import BaseComponent from "../BaseComponent";
import { Row, Col } from "../Grid";
import Customer from "./Customer";
import ResponsiveDetails from "./ResponsiveDetails";
import OwnerAnswer from "./OwnerAnswer";
import AgentAnswer from "./AgentAnswer";

type PropsType = {
  publishedAt: Date;
  customerFullname: string;
  ownerFullname: string;
  averageRate: number;
  fairnessRate: number;
  greetingRate: number;
  cosinessRate: number;
  qualityRate: number;
  title: string;
  customerContent: string;
  ownerContent: string;
  agentContent: string;
  composition: string;
};

const ResponsiveComment: React.FunctionComponent<PropsType> = (props) => {
  const {
    publishedAt,
    fairnessRate,
    greetingRate,
    cosinessRate,
    averageRate,
    qualityRate,
    title,
    customerContent,
    customerFullname,
    ownerFullname,
    ownerContent,
    agentContent,
    composition,
  } = props;

  return (
    <BaseComponent>
      <Row breakpointList={{ all: Infinity }} col={{ all: 1 }} gutter={0.3125}>
        <Col>
          <Customer
            fullname={customerFullname}
            date={publishedAt}
            composition={composition}
          />
        </Col>

        <Col span={1}>
          <ResponsiveDetails
            averageRate={averageRate}
            cosinessRate={cosinessRate}
            fairnessRate={fairnessRate}
            greetingRate={greetingRate}
            qualityRate={qualityRate}
            title={title}
            content={customerContent}
          />
        </Col>

        {null != ownerContent && (
          <Col span={1} offset={0}>
            <OwnerAnswer fullname={ownerFullname} content={ownerContent} />
          </Col>
        )}

        {null != agentContent && (
          <Col span={1} offset={0}>
            <AgentAnswer content={agentContent} />
          </Col>
        )}
      </Row>
    </BaseComponent>
  );
};

export default ResponsiveComment;
